import Socket from '../../classes/WebSocket'

class SignalingServer {
    constructor(){
        this.CreateCall = (loggedin_user_id, channel_id, to_user_id, sdp, call_user_ids,broadcast_user_ids) => {
            let RTCCreateCall = {
                "event": "SOCKET_CREATE_RTC_CALL",
                "creator_user_id": loggedin_user_id,
                "channel_id": channel_id,
                "to_user_id": to_user_id,
                "desc": sdp,
                "join": false,
                "call_user_ids": call_user_ids,
                "broadcast": {
                    "user_ids": broadcast_user_ids, // array
                }
            }
            Socket.push(RTCCreateCall)
        }


        this.JoinCall = (loggedin_user_id, channel_id, to_user_id, sdp, call_user_ids,broadcast_user_ids) => {
            let RTCCreateCall = {
                "event": "SOCKET_CREATE_RTC_CALL",
                "creator_user_id": loggedin_user_id,
                "channel_id": channel_id,
                "to_user_id": to_user_id,
                "desc": sdp,
                "join": true,
                "call_user_ids": call_user_ids,
                "broadcast": {
                    "user_ids": broadcast_user_ids,
                }
            }
            Socket.push(RTCCreateCall)
        }

        this.UpgradeCall = (loggedin_user_id, to_user_id, sdp,broadcast_user_ids) => {
            let RTCUpgrade = {
                "event": "SOCKET_UPGRADE_CALL",
                "creator_user_id": loggedin_user_id,
                "data_of_user_id": to_user_id,
                "desc": sdp,
                "broadcast": {
                    "user_ids": broadcast_user_ids,
                }
            }
            Socket.push(RTCUpgrade)
        }

        this.ResendTracks = (loggedin_user_id, to_user_id) => {
            let RTCUpgrade = {
                "event": "SOCKET_RESEND_TRACKS",
                "creator_user_id": loggedin_user_id,
                "to_user_id": to_user_id,
                "broadcast": {
                    "user_ids": [to_user_id],
                }
            }
            Socket.push(RTCUpgrade)
        }


        this.HaveRecievedUser = (loggedin_user_id, rec_user_id,broadcast_user_ids) => {
            let RTCUpgrade = {
                "event": "SOCKET_REC_USER_CALL",
                "creator_user_id": loggedin_user_id,
                "rec_user_id": rec_user_id,
                "broadcast": {
                    "user_ids": broadcast_user_ids,
                }
            }
            Socket.push(RTCUpgrade)
        }

        this.AnswerCall = (loggedin_user_id, sdp, upgrade, broadcast_user_ids) => {
            let RTCAnswer = {
                "event": "SOCKET_CREATED_ANSWER",
                "creator_user_id": loggedin_user_id,
                "desc": sdp,
                "upgrade":upgrade,
                "broadcast": {
                    "user_ids": broadcast_user_ids,
                }
            }
            Socket.push(RTCAnswer)
        }


        this.OfferICE = (loggedin_user_id, candidate, broadcast_user_ids) => {
            let rtcICEOffer = {
                "event": "SOCKET_OFFER_ICE",
                "creator_user_id": loggedin_user_id,
                "candidate": candidate,
                "broadcast": {
                    "user_ids": broadcast_user_ids,
                }
            }
            Socket.push(rtcICEOffer)
        }


        this.AnswerICE = (loggedin_user_id, candidate, broadcast_user_ids) => {
            let rtcICEAnswer = {
                "event": "SOCKET_ANSWER_ICE",
                "creator_user_id": loggedin_user_id,
                "candidate": candidate,
                "broadcast": {
                "user_ids": broadcast_user_ids,
                }
            }
            Socket.push(rtcICEAnswer)
        }

        this.AnswerICE = (loggedin_user_id, candidate, broadcast_user_ids) => {
            let rtcICEAnswer = {
                "event": "SOCKET_ANSWER_ICE",
                "creator_user_id": loggedin_user_id,
                "candidate": candidate,
                "broadcast": {
                "user_ids": broadcast_user_ids,
                }
            }
            Socket.push(rtcICEAnswer)
        }


        this.UpgradeOfferCalle = (loggedin_user_id, sdp, broadcast_user_ids) => {
            let RTCUpgradeOfferCalle = {
                "event": "SOCKET_UPGRADE_CALL_FROM_CALLEE",
                "creator_user_id": loggedin_user_id,
                "desc": sdp,
                "broadcast": {
                    "user_ids":  broadcast_user_ids,
                }
            }
            Socket.push(RTCUpgradeOfferCalle)
        }


        this.UpgradeAnswerFromCaller = (loggedin_user_id, other_user_id, sdp, other_dsp, broadcast_user_ids) => {
            let RTCUpgradeAnswerFromCaller = {
                "event": "SOCKET_UPGRADE_ANSWER_FROM_CALLER",
                "creator_user_id": loggedin_user_id,
                "from_user_id": other_user_id,
                "desc": sdp,
                "yours": other_dsp,
                "broadcast": {
                    "user_ids": broadcast_user_ids,
                }
            }
            Socket.push(RTCUpgradeAnswerFromCaller)
        }

        this.DeclineCall = (loggedin_user_id, broadcast_user_ids) => {
            let RTCDecline= {
                "event": "SOCKET_DECLINE_CALL",
                "creator_user_id": loggedin_user_id,
                "broadcast": {
                    "user_ids": broadcast_user_ids,
                }
            }
            Socket.push(RTCDecline)
        }

        this.DisableAudio = (loggedin_user_id, disabled, broadcast_user_ids) => {
            let RTCMuteAudio = {
                "event": "SOCKET_DISABLE_AUDIO",
                "creator_user_id": loggedin_user_id,
                "disabled": disabled,
                "broadcast": {
                    "user_ids": broadcast_user_ids,
                }
            }
            Socket.push(RTCMuteAudio)
        }

        this.DisableVideo = (loggedin_user_id, disabled, broadcast_user_ids) => {
            let RTCDisableVideo = {
                "event": "SOCKET_DISABLE_VIDEO",
                "creator_user_id": loggedin_user_id,
                "disabled": disabled,
                "broadcast": {
                    "user_ids": broadcast_user_ids,
                }
            }
            Socket.push(RTCDisableVideo)
        }


        this.RemoveUserFromCall = (loggedin_user_id, remove_user_id, broadcast_user_ids) => {
            let RTCSEtLeader = {
                "event": "CLEAN_REMOVE_USER",
                "creator_user_id": loggedin_user_id,
                "remove_user_id": remove_user_id,
                "broadcast": {
                    "user_ids": broadcast_user_ids
                }
            }
            Socket.push(RTCSEtLeader)
        }
    }
}

export default new SignalingServer()
